// React Query hooks for fetching email template data

import { useApiClient } from '@commander/api-client';
import { useQuery } from '@tanstack/react-query';
import type { EmailTemplateListParams } from '../../api/emailTemplateApi';
import { createEmailTemplateApi } from '../../api/emailTemplateApi';
import { communicationKeys } from '../communicationKeys';

/**
 * Hook to fetch paginated list of email templates
 * Uses React Query for automatic caching, refetching, and loading states
 */
export function useEmailTemplates(params?: EmailTemplateListParams) {
  const apiClient = useApiClient();
  const templateApi = createEmailTemplateApi(apiClient);

  return useQuery({
    queryKey: communicationKeys.templates.email.list(params),
    queryFn: () => templateApi.getEmailTemplates(params),
  });
}

/**
 * Hook to fetch a single email template by ID
 */
export function useEmailTemplate(templateId: string, options?: { enabled?: boolean }) {
  const apiClient = useApiClient();
  const templateApi = createEmailTemplateApi(apiClient);

  return useQuery({
    queryKey: communicationKeys.templates.email.detail(templateId),
    queryFn: () => templateApi.getEmailTemplate(templateId),
    enabled: options?.enabled !== false && !!templateId,
  });
}
